import { render } from "./media-block.vue?vue&type=template&id=4709a1a2"
import script from "./media-block.vue?vue&type=script&lang=js"
export * from "./media-block.vue?vue&type=script&lang=js"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__